import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M119.32 67.1699C119.32 67.1699 113.85 70 110.61 66.97C107.37 63.93 113.04 54.82 108.18 45.1C103.32 35.38 99.27 36.3899 97.65 31.5299C96.03 26.6699 95.02 9.45992 78.21 6.41992C78.21 6.41992 73.15 1.44995 61.09 1.44995C49.04 1.44995 43.28 6.41992 43.28 6.41992C26.47 9.45992 25.46 26.6699 23.84 31.5299C22.22 36.3899 18.17 35.38 13.31 45.1C8.45001 54.82 14.12 63.93 10.88 66.97C7.64002 70.01 2.17 67.1699 2.17 67.1699C0.749996 74.8699 7.44002 77.09 7.44002 77.09C6.02002 93.49 20.4 91.0599 20.4 91.0599C20.4 91.0599 30.53 94.71 35.99 84.58C43.44 70.79 34.18 52.97 34.18 52.97C38.64 45.68 35.39 41.04 39.84 33.14C44.29 25.24 60.6 28.89 60.6 28.89C60.6 28.89 77.2 25.24 81.65 33.14C86.11 41.04 82.89 47.33 87.35 54.62C87.35 54.62 78.05 70.79 85.5 84.58C90.97 94.71 101.09 91.0599 101.09 91.0599C101.09 91.0599 115.47 93.49 114.05 77.09C114.06 77.09 120.74 74.8599 119.32 67.1699Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M51.9899 28.09C51.9899 28.09 48.1399 20.1899 38.2199 21.4099C28.2999 22.6299 26.06 33.25 28.89 41.75C31.39 49.25 40.6499 62.3099 38.4199 76.0799"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M41.8007 7.56529C42.2967 7.47165 42.7998 7.40583 43.3066 7.36869L43.3066 7.36871L43.3109 7.36836C45.5399 7.18581 47.8479 7.60812 49.8956 8.59678C51.9186 9.65309 53.6893 11.1444 55.0429 12.9138L55.0481 12.9206L55.0535 12.9271C55.4078 13.3591 55.7079 13.8179 55.999 14.2958L55.9939 14.2896L55.9877 14.2822L55.9812 14.275C55.8566 14.137 55.7472 13.9951 55.6254 13.8371C55.5814 13.78 55.5357 13.7207 55.4871 13.6588C55.316 13.4408 55.1178 13.2027 54.8706 12.9947C54.6363 12.7775 54.4216 12.5634 54.2007 12.3431C54.0478 12.1907 53.892 12.0353 53.7247 11.8739C53.3369 11.4999 52.9199 11.1274 52.4434 10.8111C51.7218 10.1849 50.8948 9.72592 50.1237 9.29792C49.9823 9.21944 49.8428 9.14199 49.7061 9.06475L49.6951 9.0585L49.6837 9.05282C47.7075 8.06472 45.5235 7.6018 43.314 7.54014C42.8108 7.5261 42.306 7.53491 41.8007 7.56529Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M54.62 28.0899C54.62 28.0899 49.5 17.93 41.05 16.75C29.51 15.13 25.25 26.0699 25.25 26.0699"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M26.2699 21.2C20.7999 33.35 28.0898 54.01 30.7298 64.13C33.3598 74.26 33.0899 82.75 24.8599 84.38C18.3299 85.67 15.3399 77.7 15.3399 77.7C15.3399 77.7 14.3998 81.32 15.5398 84.99C16.8098 89.06 20.4698 93.1599 27.2898 91.6699"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M24.93 40.4199C24.93 40.4199 22.02 45.29 22.42 54.61C22.83 63.93 24.28 71.38 17.33 73.12C12.71 74.28 11.05 69.98 11.05 69.98C11.05 69.98 5.39998 76.6799 8.23998 84.7799"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M69.51 28.09C69.51 28.09 73.36 20.1899 83.28 21.4099C93.2 22.6299 95.11 34.2899 92.64 42.9099C89.67 53.3099 80.85 62.32 83.08 76.09"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M78.0561 7.21708C78.4678 7.26164 78.8766 7.32433 79.2804 7.40534C78.8688 7.38194 78.4585 7.37001 78.0499 7.37001V7.36998L78.0444 7.37004C76.1895 7.39053 74.3387 7.69723 72.6697 8.47166L72.0703 8.71729L72.031 8.73341L71.995 8.75594L71.435 9.10591L71.4247 9.11233L71.4148 9.11923C71.3045 9.1958 71.1977 9.25969 71.0763 9.33232C71.0149 9.36904 70.9497 9.40801 70.8785 9.45197C70.6885 9.56927 70.4759 9.7111 70.2835 9.89942L69.2798 10.7359L69.2502 10.7606L69.2248 10.7895L68.335 11.7992L68.3348 11.7995L67.885 12.3092L67.8627 12.3345L67.8439 12.3627L67.5508 12.8022L67.7933 12.3022L68.1918 11.7235L68.2016 11.7092L68.2105 11.6942C69.156 10.0933 70.7254 8.84395 72.4675 8.02486C74.2279 7.24576 76.1849 6.9964 78.0514 7.21656L78.0561 7.21708Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M66.8701 28.0899C66.8701 28.0899 71.9901 17.93 80.4401 16.75C91.9801 15.13 96.2401 26.0699 96.2401 26.0699"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M95.2199 21.2C100.69 33.35 93.3999 54.01 90.7599 64.13C88.1299 74.26 88.2599 83.8 96.6299 84.38C103.36 84.84 106.15 77.7 106.15 77.7C106.15 77.7 107.09 81.32 105.95 84.99C104.68 89.06 101.02 93.1599 94.1999 91.6699"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M96.4399 40.4199C96.4399 40.4199 99.4799 45.29 99.0699 54.61C98.6699 63.93 99.09 73.4499 105.75 73.0399C109.81 72.7899 109.97 69.3199 109.97 69.3199C109.97 69.3199 116.07 76.6799 113.24 84.7799"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M61.5833 23.5927C61.6815 23.0345 61.7678 22.4746 61.8431 21.9129C61.808 22.4789 61.7617 23.0441 61.7028 23.608L61.7028 23.608L61.702 23.6164C61.5597 25.2439 61.2803 26.8526 60.9554 28.4723L60.5078 28.3549C60.9363 26.7969 61.3258 25.2098 61.5833 23.5927Z"
        fill={outline}
        stroke={outline}
      />
    </g>
  )
}
